import { POST } from '@/api'
import format from 'date-fns/format'
import { getStorage, setStorage } from '@/utils/localstorageManager'

export default {
  namespaced: true,
  state: {
    selectedDate: {
      year: '',
      month: '',
    },
    selectedYearMonth: [],
    calendarArray: [],
    calendarMode: getStorage('homeCalendarMode') || 'count',
    reserveCalendar: {},
    busy: false,
  },
  mutations: {
    updateSelectedDate(state, date) {
      state.selectedDate.year = format(date, 'YYYY')
      state.selectedDate.month = format(date, 'MM')
    },
    updateSelectedYearMonth(state, yearMonth) {
      state.selectedYearMonth.push(yearMonth)
      state.selectedYearMonth.sort()
    },
    updateReserveCalendar(state, calendar) {
      state.reserveCalendar = { ...state.reserveCalendar, ...calendar }
    },
    updateCalendarArray(state, array) {
      state.calendarArray = array
    },
    updateCalendarMode(state, mode) {
      state.calendarMode = mode
    },
    busy(state, value) {
      state.busy = value
    },
  },
  actions: {
    async createCalendar(store, { date, home = false }) {
      const { commit, state } = store

      commit('busy', true)
      if (date) commit('updateSelectedDate', date)

      const { year, month } = state.selectedDate
      const yearMonth = `${year}-${month}`
      if (state.selectedYearMonth.includes(yearMonth) && !home) {
        commit('busy', false)
        return false
      }
      commit('updateSelectedYearMonth', yearMonth)

      // TODO: calendarの綴り修正（BEと同時に対応）
      const { status, message, data } = await POST('/api/web/store/calender/view', state.selectedDate)

      if (status === 200) {
        commit('updateCalendarArray', data.calendar)
        // HOME画面以外でupdateReserveCalendarをcommitする
        if (!home && data.calendar.length) {
          commit(
            'updateReserveCalendar',
            data.calendar.reduce((accumulator, { day, dinner, lunch, month: currentMonth, year: currentYear }) => {
              if (dinner || lunch) accumulator[`${currentYear}-${currentMonth}-${day}`] = { dinner, lunch }
              return accumulator
            }, {}),
          )
        }
      } else {
        commit('app/error', { status, message }, { root: true })
      }
      commit('busy', false)

      return status === 200
    },
    setCalendarMode({ commit }, mode) {
      commit('updateCalendarMode', mode)
      setStorage('homeCalendarMode', mode)
    },
  },
}
